import { Course, Data, Matches, Match, TeamGameMatch } from '../../../database.schema';
import { AWAITING_SCORES } from '../../app/constants';
import { useFetchData } from '../tournament-data';

export type ResultAwaitingScores = {
  matches?: Matches;
  resultIndex: number;
  courses: Array<Course>;
};
export const useFetchResultsAwaitingScores = (selectedIndex: number) => {
  return useFetchData((data: Data): ResultAwaitingScores => {
    const results: Matches[] = data.tournaments[selectedIndex]?.ryderCup?.results ?? [];
    const courses = data.courses;

    if (results) {
      const resultIndex = results.findIndex((result: Matches) => result.matches.filter((match: Match) => match?.status === AWAITING_SCORES).length > 0);
      if (resultIndex > -1) {
        return {
          matches: { ...results[resultIndex] },
          resultIndex,
          courses,
        };
      }
    }
    return {
      resultIndex: -1,
      courses,
    };
  });
};

export type TeamGameMatchAwaitingScores = {
  match?: TeamGameMatch;
  resultIndex: number;
  nextMatchIndex?: number;
  courses: Array<Course>;
};
export const useFetchTeamGameMatchAwaitingScores = (selectedIndex: number) => {
  return useFetchData((data: Data): TeamGameMatchAwaitingScores => {
    const results: TeamGameMatch[] = data.tournaments[selectedIndex]?.teamGames?.matches ?? [];

    if (results) {
      const resultIndex = results.findIndex((result: TeamGameMatch) => result?.teams.some((team) => !team.scoresEntered));
      if (resultIndex > -1) {
        return {
          match: results[resultIndex],
          resultIndex,
          courses: data.courses,
        };
      }
    }
    return {
      resultIndex: -1,
      nextMatchIndex: results.length,
      courses: data.courses,
    };
  });
};
